import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_COORDINATES, GET_COORDINATES_SUCCESS, GET_COORDINATES_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCoordinates({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/find-${payload?.coordinateType}-coordinates`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_COORDINATES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COORDINATES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COORDINATES_ERROR, payload: error });
  }
}

export function* watchgetCoordinates() {
  yield takeEvery(GET_COORDINATES, getCoordinates);
}

function* getCoordinatesSaga() {
  yield all([fork(watchgetCoordinates)]);
}

export default getCoordinatesSaga;
